import { CookiesKeys } from '@Engage.Data/constants/Constants';
import { CookiesStorageService } from '@Engage.Data/services';
export class Auth0Repository {
    getAuth0AccountId() {
        let cookieOptions = this.getGetterOptions();
        return CookiesStorageService.get(CookiesKeys.Auth0AccountId, cookieOptions);
    }
    setAuth0AccountId(accId, daysOfLife) {
        const cookieOptions = this.getSetterOptions(daysOfLife);
        CookiesStorageService.set(CookiesKeys.Auth0AccountId, accId, cookieOptions);
    }
    deleteAuth0AccountId() {
        CookiesStorageService.delete(CookiesKeys.Auth0AccountId, this.getGetterOptions());
    }
    getAuth0JwtCookie() {
        let cookieOptions = this.getGetterOptions();
        return CookiesStorageService.get(CookiesKeys.Auth0Jwt, cookieOptions);
    }
    setAuth0JwtCookie(rawJwt, daysOfLife) {
        const cookieOptions = this.getSetterOptions(daysOfLife);
        CookiesStorageService.set(CookiesKeys.Auth0Jwt, rawJwt, cookieOptions);
    }
    deleteAuth0JwtCookie() {
        CookiesStorageService.delete(CookiesKeys.Auth0Jwt, this.getGetterOptions());
    }
    // Mirrors ConneXt v2 Mg2Account.hasIsActualData() / setActualDataOnDay()
    // Cookie key matches CookiesKeys.UserDataExpiration = 'nxt_AccountDataExpirationCookie'
    getUserDataExpiration() {
        return CookiesStorageService.get(CookiesKeys.UserDataExpiration, this.getGetterOptions());
    }
    setUserDataExpiration(daysOfLife) {
        CookiesStorageService.set(CookiesKeys.UserDataExpiration, 'actual', this.getSetterOptions(daysOfLife));
    }
    deleteUserDataExpiration() {
        CookiesStorageService.delete(CookiesKeys.UserDataExpiration, this.getGetterOptions());
    }
    getSetterOptions(daysOfLife) {
        return {
            daysOfLife: daysOfLife,
            expandKey: false,
            useRootDomain: true,
        };
    }
    getGetterOptions() {
        return {
            expandKey: false,
            useRootDomain: true
        };
    }
}
